import React from 'react'

const IconPlus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M14.7 13.6V0h-1.1v13.6H0v1.1h13.6v13.6h1.1V14.7h13.6v-1.1z" />
  </svg>
)

export default IconPlus
